(() => {
  const media = window.matchMedia('(min-width: 769px)');
  const initialize = (scope = document) => {
    scope.querySelectorAll('.footer-accordion').forEach((details) => {
      if (details.dataset.footerInitialized) return;
      details.dataset.footerInitialized = 'true';
      const summary = details.querySelector('summary');
      const sync = () => { details.open = media.matches; summary.tabIndex = media.matches ? -1 : 0; };
      sync();
      summary.addEventListener('click', (event) => { if (media.matches) event.preventDefault(); });
      media.addEventListener('change', sync);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
